import { RefObject, useEffect } from 'react'

import { DialogStack } from 'ui/core'

export const useStack = (ref: RefObject<HTMLElement | null>) => {
  const stack = DialogStack.getInstance()

  useEffect(() => {
    const id = ref.current

    if (id) {
      stack.push(id)
    }
    return () => {
      if (id) {
        stack.remove(id)
      }
    }
  }, [stack, ref])
}
